var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVinte = function SvgVinte(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "40 40 320 320"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M160 160h80v80h-80Zm0-20V80l40-40 40 40v60Zm32-42v24h16V98Zm48 162v60l-40 40-40-40v-60Zm-48 18v24h16v-24Zm68-118h60l40 40-40 40h-60Zm18 32v16h24v-16Zm-138 48H80l-40-40 40-40h60Zm-42-48v16h24v-16Z"
  })));
};
export default SvgVinte;